export default __webpack_public_path__ + "static/media/shareFb.3b01b1a3.svg";